import { render, staticRenderFns } from "./specTable.vue?vue&type=template&id=1dd8b2f6"
import script from "./specTable.vue?vue&type=script&lang=js"
export * from "./specTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports